import type { FC, ReactElement, ReactNode } from 'react'
import { useState } from 'react'

import type { WhiteLabel } from '@skytech/types'
import ChevronUpIcon from 'mdi-react/ChevronUpIcon'
import CookieOutlineIcon from 'mdi-react/CookieOutlineIcon'

import { Button } from '../Button'
import { ExternalLink } from '../ExternalLink'
import { Icon } from '../Icon'

import './styles.scss'

export const CookieConsent: FC<{
  onTranslate: (
    id: string,
    values?: Record<string, string | ReactElement>
  ) => string | ReactNode | ReactNode[]
  onRejectCookies: () => void
  whiteLabel?: WhiteLabel
}> = ({ onTranslate, onRejectCookies, whiteLabel }) => {
  const [cookieConsent, setCookieConsent] = useState(localStorage.getItem('cookieConsent'))
  const [isBannerCollapsed, setIsBannerCollapsed] = useState(
    localStorage.getItem('cookieConsent') === 'false'
  )

  return (
    <div
      className={`ui-cookie-consent ${
        cookieConsent === 'true'
          ? 'with-consent'
          : cookieConsent === 'false' && isBannerCollapsed
            ? 'without-consent'
            : ''
      } ${isBannerCollapsed ? 'collapsed' : ''}`}
    >
      {isBannerCollapsed && (
        <Button
          className="m-0"
          variant="tertiary"
          Icon={<ChevronUpIcon />}
          onClick={() => setIsBannerCollapsed(false)}
          whiteLabel={whiteLabel}
        />
      )}

      <div>
        <p className="consent-content">
          <Icon block whiteLabel={whiteLabel}>
            <CookieOutlineIcon className="cookie-icon" />
          </Icon>

          <span>
            {onTranslate(
              'This website uses cookies to ensure you get the best experience on our website. Please review our {privacyNote}.',
              {
                privacyNote: (
                  <ExternalLink href="https://skytechcontrol.io/privacy-notice/">
                    {onTranslate('privacy note')}
                  </ExternalLink>
                ),
              }
            )}
          </span>
        </p>
      </div>

      <div className="buttons">
        <Button
          size="small"
          variant="primary"
          onClick={() => {
            setCookieConsent('true')
            localStorage.setItem('cookieConsent', 'true')
          }}
          whiteLabel={whiteLabel}
        >
          {onTranslate('Accept')}
        </Button>
        <Button
          size="small"
          onClick={() => {
            onRejectCookies()
            setCookieConsent('false')
            setIsBannerCollapsed(true)
            localStorage.setItem('cookieConsent', 'false')
          }}
          whiteLabel={whiteLabel}
        >
          {onTranslate('Reject')}
        </Button>
      </div>
    </div>
  )
}
